import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

import PortalLayout from "@/pages/portal/PortalLayout";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalNewRequest from "@/pages/portal/PortalNewRequest";
import PortalCases from "@/pages/portal/PortalCases";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminMessages from "@/pages/admin/AdminMessages";

import NotFound from "@/pages/NotFound";

function PublicShell({ children }) {
    return (
        <>
            <Navbar />
            <main className="pt-20">{children}</main>
            <Footer />
        </>
    );
}

function App() {
    return (
        <div className="App min-h-screen bg-ink-900 text-white">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                        <Route path="/services" element={<PublicShell><Services /></PublicShell>} />
                        <Route path="/services/:slug" element={<PublicShell><ServiceDetail /></PublicShell>} />
                        <Route path="/about" element={<PublicShell><About /></PublicShell>} />
                        <Route path="/blog" element={<PublicShell><Blog /></PublicShell>} />
                        <Route path="/blog/:slug" element={<PublicShell><BlogPost /></PublicShell>} />
                        <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
                        <Route path="/booking" element={<PublicShell><Booking /></PublicShell>} />
                        <Route path="/login" element={<PublicShell><Login /></PublicShell>} />
                        <Route path="/register" element={<PublicShell><Register /></PublicShell>} />

                        {/* Portal */}
                        <Route
                            path="/portal"
                            element={
                                <ProtectedRoute>
                                    <PortalLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<PortalDashboard />} />
                            <Route path="new-request" element={<PortalNewRequest />} />
                            <Route path="cases" element={<PortalCases />} />
                        </Route>

                        {/* Admin */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute requireAdmin>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<AdminDashboard />} />
                            <Route path="requests" element={<AdminRequests />} />
                            <Route path="bookings" element={<AdminBookings />} />
                            <Route path="messages" element={<AdminMessages />} />
                        </Route>

                        <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    theme="dark"
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#141414",
                            border: "1px solid rgba(212,175,55,0.25)",
                            color: "#fff",
                        },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;
